import { setLocale } from 'yup';

const setValidationMessages = setLocale;

export { setValidationMessages };
